// unsaved-changes.service.ts
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  private showModalSubject = new BehaviorSubject<boolean>(false);
  public showModal$ = this.showModalSubject.asObservable();

  // Event emitter to communicate the user's decision
  public userDecision = new EventEmitter<boolean>();

  public toggleModal(show: boolean): void {
    this.showModalSubject.next(show);
  }

  // Method to report user decision
  public reportDecision(decision: boolean): void {
    this.userDecision.emit(decision);
  }
}
